<div class="grid-center-column-items justify-start item-selection-text">
  <span *ngIf="count < 2"> {{ count }} Item selected </span>
  <span *ngIf="count >= 2"> {{ count }} Items selected </span>
</div>
